/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_ToInputs */

const es_chat_tool_detail_to = /** @type {(inputs: Chat_Tool_Detail_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para`)
};

const en_chat_tool_detail_to = /** @type {(inputs: Chat_Tool_Detail_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Chat_Tool_Detail_ToInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_to = /** @type {((inputs?: Chat_Tool_Detail_ToInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_ToInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_to(inputs)
	return en_chat_tool_detail_to(inputs)
});
export { chat_tool_detail_to as "chat.tool_detail.to" }